import React, { useState } from 'react';
import './DomainStep.scss';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useProjectWizard } from '../../contexts/ProjectWizardContext';
import Loader from '../../../../../shared/components/common/loader/Loader';
import { DOMAIN_REGEX } from '../../../../../shared/utils/regex';
import { getQuestions } from '../../../../../shared/services/projects/ProjectService';
import { cleanDomain } from '../../../../../shared/utils/utils';

const DomainStep: React.FC = () => {
  const { setActiveStep, setQuestionResponse, setDomain } = useProjectWizard();
  const [loading, setLoading] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [apiError, setApiError] = useState<string | null>(null);

  const onSubmit = async (loginFormData: any) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setLoading(true);
    const domain = cleanDomain(loginFormData.domain).trim();
    getQuestions(domain, true)
      .then((data) => {
        setLoading(false);
        setQuestionResponse(data);
        setActiveStep('QUESTIONS');
        setDomain(domain);
      })
      .catch((err) => {
        setApiError(err.message);
      })
      .finally(() => {
        setLoading(false);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      {loading && <Loader loadingLabel="loadingDataThisMayTakeAMoment" />}
      <form onSubmit={handleSubmit(onSubmit)} className="project-wizard__page-box">
        <div className="project-wizard__form">
          <div className="form-box__row">
            <h2>{t('enterDomain')}</h2>
            <div
              className="project-wizard__desc"
              dangerouslySetInnerHTML={{ __html: t('enterDomainDesc') }}
            />
            <div className="form-box__label">{t('domain')}:</div>
            <InputText
              {...register('domain', {
                required: t('fieldIsRequired'),
                pattern: {
                  value: DOMAIN_REGEX,
                  message: t('wrongDomain'),
                },
              })}
              placeholder="example.com"
              className={errors.domain || apiError ? 'form-box__invalid' : ''}
            />
            {errors.domain && <span>{errors.domain.message as string}</span>}
          </div>
        </div>
        <div className="project-wizard__action">
          <div>
            <Button className="btn btn--sm" type="submit" disabled={isSubmitting}>
              {t('next')}
            </Button>
          </div>
          <div className="project-wizard__link">
            {t('linkToBrandNameStep')}
            <Button
              className="btn--link btn--link-black"
              label={t('clickHere')}
              onClick={() => setActiveStep('FIRM_NAME')}
            />
          </div>
          <div className="project-wizard__note">{t('noteHistorical')}</div>
        </div>
      </form>
    </>
  );
};

export default DomainStep;
